<template>
  <div>
    <v-layout class="align-center">
      <h5 class="pl-2">
        Submitted by {{ student.station }} on {{ date }} - {{ time }}
      </h5>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="$emit('edit')">Edit</v-btn>
    </v-layout>
    <v-text-field
      label="First Name"
      v-model="student.first_name"
    ></v-text-field>
    <v-text-field label="Last Name" v-model="student.last_name"></v-text-field>
    <v-text-field
      label="Parent/Guardian Name"
      v-model="student.parent_name"
    ></v-text-field>

    <v-text-field label="Event" v-model="reasonEvent"></v-text-field>
    <v-text-field v-if="inDate" label="In Date" v-model="inDate"></v-text-field>
    <v-text-field v-if="inTime" label="In Time" v-model="inTime"></v-text-field>
    <v-text-field
      v-if="outDate"
      label="Out Date"
      v-model="outDate"
    ></v-text-field>
    <v-text-field
      v-if="outTime"
      label="Out Time"
      v-model="outTime"
    ></v-text-field>
    <v-text-field label="Reason" v-model="student.reason"></v-text-field>
    <label>Signature</label><br />
    <img :src="this.student.image" />
  </div>
</template>

<script>
import APIAttendance from "@/mixins/APIAttendance";
export default {
  components: {},
  mixins: [APIAttendance],
  data() {
    return {
      student: {},
      date: "",
      time: "",
      inDate: "",
      outDate: "",
      inTime: "",
      outTime: "",
      sign_in_reason: "",
      reasonEvent: ""
    };
  },
  computed: {
    queriedUrlId() {
      let url = window.location.href.split("view/");
      let url1 = url[1].split("/");
      return url1[0];
    }
  },
  watch: {},
  created() {
    this.restoreFrom();
  },
  methods: {
    restoreFrom: async function() {
      if (this.$route.params.object !== undefined) {
        this.student = this.$route.params.object;

        let stateTime = this.$route.params.object.updated_date;
        let arrayDate = stateTime.split("T");
        this.date = arrayDate[0];
        let arrayTime = arrayDate[1].split(".");
        this.time = arrayTime[0];

        // if (this.$route.params.object.complete === false) {
        //   this.inDate = this.$route.params.object.sign_in_date;
        //   this.inTime = this.$route.params.object.sign_in_time;
        //   this.sign_in_reason = this.$route.params.object.reason;
        //   this.reasonEvent = "Sign In";
        // } else {
        //   this.inDate = this.$route.params.object.sign_out_date;
        //   this.inTime = this.$route.params.object.sign_out_time;
        //   this.sign_in_reason = this.$route.params.object.reason;
        //   this.reasonEvent = "Sign Out";
        // }

        if (
          this.$route.params.object.sign_in_date &&
          this.$route.params.object.sign_out_date
        ) {
          this.reasonEvent = "In / Out";
          this.outDate = this.$route.params.object.sign_out_date;
          this.inDate = this.$route.params.object.sign_in_date;
          this.inTime = this.$route.params.object.sign_in_time;
          this.outTime = this.$route.params.object.sign_out_time;
          this.student.reason = this.$route.params.object.sign_in_reason;
        } else if (this.$route.params.object.sign_in_date) {
          this.reasonEvent = "Sign In";
          this.inDate = this.$route.params.object.sign_in_date;
          this.inTime = this.$route.params.object.sign_in_time;
          this.student.reason = this.$route.params.object.sign_in_reason;
        } else {
          this.reasonEvent = "Sign Out";
          this.outDate = this.$route.params.object.sign_out_date;
          this.outTime = this.$route.params.object.sign_out_time;
          this.student.reason = this.$route.params.object.sign_out_reason;
        }

        this.student.image =
          "data:image/jpeg;base64," + this.$route.params.object.signature;
        // if (this.$route.params.object.sign_out_reason) {
        //   this.student.reason = this.$route.params.object.sign_out_reason;
        // } else if (this.$route.params.object.sign_in_reason) {
        //   this.student.reason = this.$route.params.object.sign_in_reason;
        // }
      } else if (
        this.$route.params.object === undefined &&
        this.queriedUrlId !== "0"
      ) {
        try {
          let htype = "student";
          let res = await this.geHistoricalListById(this.queriedUrlId, htype);

          let stateTime = res[0].updated_date;
          let arrayDate = stateTime.split("T");
          this.date = arrayDate[0];
          let arrayTime = arrayDate[1].split(".");
          this.time = arrayTime[0];

          // if (res[0].complete === false) {
          //   this.inDate = res[0].sign_in_date;
          //   this.inTime = res[0].sign_in_time;
          //   this.sign_in_reason = res[0].reason;
          //   this.reasonEvent = "Sign In";
          //   console.log(this.student.reasonEvent);
          // } else {
          //   this.inDate = res[0].sign_out_date;
          //   this.inTime = res[0].sign_out_time;
          //   this.sign_in_reason = res[0].reason;
          //   this.reasonEvent = "Sign Out";
          // }

          if (res[0].sign_in_date && res[0].sign_out_date) {
            this.reasonEvent = "In / Out";
            this.outDate = res[0].sign_out_date;
            this.inDate = res[0].sign_in_date;
            this.inTime = res[0].sign_in_time;
            this.outTime = res[0].sign_out_time;
            this.student.reason = res[0].sign_in_reason;
          } else if (res[0].sign_in_date) {
            this.reasonEvent = "Sign In";
            this.inDate = res[0].sign_in_date;
            this.inTime = res[0].sign_in_time;
            this.student.reason = res[0].sign_in_reason;
          } else {
            this.reasonEvent = "Sign Out";
            this.outDate = res[0].sign_out_date;
            this.outTime = res[0].sign_out_time;
            this.student.reason = res[0].sign_out_reason;
          }

          this.student = res[0];
          this.student.image =
            "data:image/jpeg;base64," + this.student.signature;
          // if (res[0].sign_out_reason) {
          //   this.student.reason = res[0].sign_out_reason;
          // } else if (res[0].sign_in_reason) {
          //   this.student.reason = res[0].sign_in_reason;
          // }
        } catch (error) {
          this.$toast.error("Cannot get details!", "Error", {
            position: "topCenter"
          });
        }
      }
    }
  }
};
</script>
